import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/logo.svg'
import _imports_1 from '@/assets/images/user-icon.png'


const _hoisted_1 = { class: "header search" }
const _hoisted_2 = { class: "d-flex container align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Info Global Logo"
}, null, -1)
const _hoisted_4 = { class: "search-header__search col-md-6 me-auto" }
const _hoisted_5 = { class: "login d-flex ms-auto" }
const _hoisted_6 = {
  key: 0,
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#authModal"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "User Icon"
}, null, -1)
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Burger = _resolveComponent("Burger")!
  const _component_SearchComponent = _resolveComponent("SearchComponent")!
  const _component_Translator = _resolveComponent("Translator")!
  const _component_AuthModal = _resolveComponent("AuthModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_Burger, { class: "ms-md-auto me-4" }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SearchComponent)
        ]),
        _createVNode(_component_Translator),
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.isLoggedIn || !_ctx.currentUser)
            ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
                _createTextVNode("Войти "),
                _hoisted_7
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_router_link, { to: "/profile/info" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.currentUser.full_name), 1)
                  ]),
                  _: 1
                }),
                (_ctx.currentUser?.avatar)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.currentUser?.avatar,
                      class: "ms-2 photo",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/profile/info')))
                    }, null, 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_1,
                      class: "ms-2 photo",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/profile/info')))
                    }))
              ], 64))
        ])
      ])
    ]),
    _createVNode(_component_AuthModal)
  ], 64))
}